import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SubMenu from './SubMenu';

function Layout() {
    const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <div>
    <div className='header'>
    <header className={`header style_2 sticky-header ${isSticky ? 'sticky' : ''}`}>
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="inner">
                        <div className="logo">
                            <Link to="/" className="d-flex h-100">
                                <img src="/tm/react/roboto/assets/images/logo.png" alt="logo" className="image-fit-contain"/>
                            </Link>
                        </div>
                       
                        <nav className="navigation">
                            <ul className="main-menu">
                                <li className="menu-item menu-item-has-children">
                                    <Link to="#" className="active">Home</Link>
                                    <ul className="sub-menu">
                                        <li className="menu-item">
                                            <Link to="/">Homepage v1</Link>
                                        </li>
                                        <li className="menu-item">
                                            <Link to="/home-v2">Homepage v2</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item">
                                    <Link to="/about">About</Link>
                                </li>
                                <li className="menu-item menu-item-has-children">
                                    <Link to="#">Services</Link>
                                    <ul className="sub-menu">
                                        <li className="menu-item">
                                            <Link to="/services">Services</Link>
                                        </li>
                                        <li className="menu-item">
                                            <Link to="/service-details">Service Details</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item">
                                    <Link to="/team">Team</Link>
                                </li>
                                <li className="menu-item menu-item-has-children">
                                    <Link to="#">Blog</Link>
                                    <ul className="sub-menu">
                                        <li className="menu-item menu-item-has-children">
                                            <Link to="#">Blog Grid</Link>
                                            <ul className="sub-menu">
                                                <li className="menu-item">
                                                    <Link to="/blog-grid">Full Width</Link>
                                                </li>
                                                <li className="menu-item">
                                                    <Link to="/blog-grid-left">Left Sidebar</Link>
                                                </li>
                                                <li className="menu-item">
                                                    <Link to="/blog-grid-right">Right Sidebar</Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="menu-item">
                                            <Link to="/blog-details">Blog Details</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item">
                                    <Link to="/contact">Contact</Link>
                                </li>
                            </ul>
                            <div className="header_action">
                                <Link to="#" className="header_btn thm-btn btn-rounded btn-small"><span className="button_title">Log In</span></Link>
                            </div>
                        </nav>
                        <div className="hamburger">
                            <SubMenu/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    </div>
    </div>
  )
}

export default Layout